/**
 * Модуль инициализации uiSlider.
 * Находим элемент по селектору и инициализируем его
 */
itsoftApp.createModule('noUiSliderInit', ['noUiSliderLibrary'], function () {
    // Локальные переменные
    let module = this;

    const sliderConfig = {
        name: 'babyBornCounter',
        events: {
            update: function (value) {
                const childrenCountInput = document.getElementById('children-count');
                const [val] = value;

                if (childrenCountInput) {
                    childrenCountInput.value = val;
                }
            },
            change: function () {
                const childrenCountInput = document.getElementById('children-count');

                if (childrenCountInput) {
                    let event = new Event("change");
                    childrenCountInput.dispatchEvent(event);
                }
            },
        }
    };

    const noUiSliderInit = function () {
        const slider = document.querySelector('.js-ui-range-slider');

        if (slider) {
            itsoftApp.modules.noUiSliderLibrary.callback(slider, sliderConfig);
        }
    };

    noUiSliderInit();
    module.callback = noUiSliderInit;
});
